export default __webpack_public_path__ + "static/media/oscer-pres-epistaxis-nose-bleeds.2a578618.svg";